import React from 'react';

import { FeaturedPartner } from '../../utils/backend-api/partners';
import { isExternalURL } from '../../utils/url_validations';
import { Button } from '../BaseUI';
import styles from './styles.module.scss';

interface FeaturedPartnerCardProps {
  partner: FeaturedPartner;
}

const FeaturedPartnerCard = ({ partner }: FeaturedPartnerCardProps) => {
  const { id, logo, description, buttonText, targetLink } = partner;
  const externalLinkAttributes = isExternalURL(targetLink, window.location)
    ? { target: '_blank', rel: 'sponsored' }
    : {};

  return (
    <div className={styles.partner}>
      <img src={logo} className={styles.logo} />
      <div className={styles.details}>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          href={targetLink}
          className={styles.button}
          variant="outline"
          rounded="slight"
          borderWidth="medium"
          trackClick
          trackingProps={{
            name: 'partner_card',
            identifier: id.toString(),
          }}
          {...externalLinkAttributes}
        >
          {buttonText || 'LEARN MORE'}
        </Button>
      </div>
    </div>
  );
};

export default FeaturedPartnerCard;
